module.exports = __webpack_public_path__ + "fonts/Merriweather-500-cyrillic-ext17.4adbd98.woff2";